import debug from 'debug';
const error = debug('core:error');
const ERROR_UNKNOWN = 'Unknown error';
export function extractErrorMessageAndKey(err) {
    if (!err)
        return { message: ERROR_UNKNOWN, key: '' };
    let message;
    let key = '';
    if (typeof err === 'string')
        message = err;
    else if (err.isAxiosError) {
        const data = err.response?.data;
        if (data && typeof data === 'object') {
            message = data.message;
            key = data.key ?? '';
        }
        else if (typeof data === 'string')
            message = data;
        if (!message)
            message = err.message;
        if (!key)
            key = String(err.response?.status ?? err.message);
    }
    else
        message = err.message || err.responseText;
    //                                                               
    //             
    if (message != null && typeof message !== 'string') {
        message = (typeof message === 'object' && typeof message.message === 'string') ? message.message : JSON.stringify(message);
    }
    if (typeof message === 'string') {
        //                                                           
        try {
            const parsed = JSON.parse(message);
            if (parsed && typeof parsed.message === 'string' && parsed.message) {
                message = parsed.message;
            }
        }
        catch {
            //             
        }
        if (message) {
            //                        
            if (message.startsWith('<html')) {
                const match = message.match(/<h1>(.+?)<\/h1>/);
                if (match?.[1]) {
                    message = match[1];
                }
            }
            return { message, key };
        }
    }
    if (typeof err === 'object' && err !== null && 'status' in err) {
        const fallback = err.responseText || `Network error: ${err.status}`;
        return { message: fallback, key: String(err.status) };
    }
    error('[extractErrorMessage] failed to extract message', err);
    return { message: ERROR_UNKNOWN, key: '' };
}
/* 
                                        
                                         
  
             
                    
 */
export function extractErrorMessage(err) {
    return extractErrorMessageAndKey(err).message;
}
